<template>
  <div v-loading="pageLoading">
    <el-form class="full-width mb-2px" :model="filterForm">
      <div class="filter-bar" type="flex">
        <el-form-item class="mb-none">
          <school-year-selector
            v-model="filterForm.schoolYear"
            @change="refresh"
          ></school-year-selector>
        </el-form-item>
        <el-form-item class="mb-none">
          <school-term-selector
            v-model="filterForm.schoolTerm"
            @change="refresh"
            :checkAll="false"
          ></school-term-selector>
        </el-form-item>
        <el-form-item class="mb-none">
          <el-select
            size="small"
            value-key="grade"
            v-model="filterForm.disciplineCode"
            placeholder="请选择学科"
            clearable
            @change="refresh"
          >
            <el-option
              v-for="item in disciplineOptions"
              :value="item.disciplineCode"
              :label="item.disciplineName"
              :key="item.disciplineCode"
            ></el-option
          ></el-select>
        </el-form-item>
        <el-form-item class="mb-none">
          <el-select
            size="small"
            value-key="grade"
            v-model="filterForm.grade"
            placeholder="请选择年级"
            clearable
            @change="refresh"
          >
            <el-option
              v-for="item in gradeOptions"
              :value="{ grade: item.grade, gradeName: item.gradeName }"
              :key="item.grade"
              :label="item.gradeName"
            ></el-option
          ></el-select>
        </el-form-item>
        <el-form-item class="mb-none">
          <el-select
            size="small"
            value-key="grade"
            v-model="filterForm.activeStatus"
            placeholder="请选择状态"
            clearable
            @change="refresh"
          >
            <el-option
              v-for="item in statusOptions"
              :value="item.value"
              :label="item.label"
              :key="item.key"
            ></el-option
          ></el-select>
        </el-form-item>
        <el-form-item class="mb-none">
          <el-input
            size="small"
            v-model="filterForm.keyword"
            clearable
            placeholder="搜索活动名称"
            style="width: 250px"
            @keydown.enter="refresh"
            @change="refresh"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
        <el-button size="small" type="primary" @click="onReset">重置</el-button>
        <div class="space"></div>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="onAdd"
          >创建活动</el-button
        >
      </div></el-form
    >
    <div class="data-list" v-loading="pageLoading">
      <card-list
        moduleType="researchGroupTopic"
        :dataList="tableData"
        @delSuccess="refresh"
        @toPathEdit="toPathEdit"
      ></card-list>
    </div>

    <pagination
      class="mb-md mr-md"
      slot="append"
      :pageObj="filterForm"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></pagination>
  </div>
</template>

<script>
import schoolYearSelector from "@/components/school/schoolYearSelector.vue";
import SchoolTermSelector from "@/components/school/schoolTermSelector.vue";
import Pagination from "@/components/Pagination.vue";
import CardList from "@/components/researchGroup/CardList.vue";
import { mapGetters, mapState } from "vuex";
import { postData, postJson } from "@/http/fetch";
export default {
  components: {
    schoolYearSelector,
    SchoolTermSelector,
    Pagination,
    CardList,
  },
  data() {
    return {
      filterForm: {
        schoolYear: null,
        schoolTerm: null,
        keyword: null,
        checkStatus: null,
        disciplineCode: null,
        activeStatus: null,
        grade: null,
        size: 10,
        current: 1,
        total: 0,
      },
      userOptions: [],
      tableData: [],
      gradeOptions: [],
      disciplineOptions: [],
      pageLoading: false,
      saving: false,
      statusOptions: [
        { label: "未开始", value: 0 },
        { label: "进行中", value: 1 },
        { label: "已结束", value: 2 },
      ],
    };
  },
  computed: {
    ...mapState(["userInfo", "isAdmin"]),
    ...mapGetters(["schoolCode"]),
  },
  mounted() {
    this.getData();
    this.getGradeList();
    this.getDisciplineFieldlList();
  },
  methods: {
    async getData() {
      this.loading = true;
      await postJson("/researchGroup/getGroupActiveList", {
        schoolCodes: this.schoolCodes,
        operatorId: this.userInfo.userId,
        schoolCode: this.userInfo.schoolCode,
        pageNum: this.filterForm.current,
        pageSize: this.filterForm.size,
        schoolYear: this.filterForm.schoolYear,
        schoolTerm: this.filterForm.schoolTerm,
        disciplineCode: this.filterForm.disciplineCode,
        grade: this.filterForm.grade ? this.filterForm.grade.grade : null,
        keyword: this.filterForm.keyword,
        isAdmin: this.isAdmin / 1,
        activeStatus: this.filterForm.activeStatus,
        actType: "topic",
      })
        .then((res) => {
          this.tableData = res.records;
          this.filterForm.size = res.size;
          this.filterForm.total = res.total;
          this.filterForm.current = res.current;
        })
        .catch((e) => {
          this.tableData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    refresh() {
      this.filterForm.pageNum = 1;
      this.getData();
    },
    async getDisciplineFieldlList() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        postData("/discipline/getDisciplinelList", {
          schoolCode: this.schoolCode,
        })
          .then((res) => {
            if (res.length) {
              res = res.map((m) => {
                return {
                  disciplineCode: m.disciplineCode,
                  disciplineName: m.disciplineName,
                };
              });
              this.disciplineOptions = res;
            } else {
              this.disciplineOptions = [];
            }
            resolve(res);
          })
          .catch((e) => {
            reject();
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    async getGradeList() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        postData("/school/getGradeList", { schoolCode: this.schoolCode })
          .then((res) => {
            let list = [];
            if (res.length) {
              list = res;
              this.gradeOptions = res;
              resolve(list);
            } else {
              this.gradeOptions = [];
              reject();
            }
          })
          .catch((e) => {
            reject(e);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    onReset() {
      this.filterForm.disciplineCode = null;
      this.filterForm.schoolYear = null;
      this.filterForm.schoolTerm = null;
      this.filterForm.keyword = null;
      this.filterForm.grade = null;
      this.filterForm.activeStatus = null;
      this.refresh();
    },
    onAdd() {
      sessionStorage.removeItem("actCode");
      this.$router.push("editResearchGroupTopic");
    },
    async toPathEdit(actCode) {
      sessionStorage.setItem("actCode", actCode);
      this.$router.push("editResearchGroupTopic");
    },
    handleSizeChange(pageSize) {
      this.filterForm.current = 1;
      this.filterForm.size = pageSize;
      this.getData();
    },
    handleCurrentChange(curPage) {
      this.filterForm.current = curPage;
      this.getData();
    },
  },
};
</script>

<style lang="less" >
.data-list {
  margin-top: 15px;
  background: #fff;
  padding: 15px;
  border-radius: 10px;
}
</style>